import { FC, KeyboardEvent, FocusEvent } from 'react';
import s from './EditableString.module.scss';
import cn from 'classnames';

interface IEditableString {
  id: string;
  stringType: string;
  value: string;
  onDoubleClick: () => void;
  onBlurField: (
    id: string,
    e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
    stringType: string,
  ) => void;
  onEnter?: (
    id: string,
    e: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>,
    stringType: string,
  ) => void;
  onEscape?: () => void;
  onlyNumber?: boolean;
  numberStep?: number;
  isTextarea?: boolean;
  isEditable?: boolean;
}

export const EditableString: FC<IEditableString> = ({
  id,
  stringType,
  value,
  onDoubleClick,
  onBlurField,
  onEnter,
  onEscape,
  onlyNumber,
  numberStep = 1,
  isTextarea,
  isEditable,
}) => {
  const InputComponent = isTextarea ? 'textarea' : 'input';

  return isEditable ? (
    <InputComponent
      type={onlyNumber ? 'number' : 'text'}
      step={numberStep}
      defaultValue={value}
      className={s.editableString__editInput}
      onBlur={(e) => onBlurField(id, e, stringType)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && onEnter) onEnter(id, e, stringType);

        if (e.key === 'Escape' && onEscape) onEscape();
      }}
      rows={4}
      autoFocus
    />
  ) : (
    <span
      className={cn(s.editableString__string, 'user-select-none')}
      onDoubleClick={onDoubleClick}
    >
      {value ?? '—'}
    </span>
  );
};
